module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity/brag/brag-09-73a2e4e6f8cfedbfcf278dfec897aad9.jpg";